import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { EmbrCaseStudy } from './pages/EmbrCaseStudy';
import { GinkgoCaseStudy } from './pages/GinkgoCaseStudy';
import { InnermapCaseStudy } from './pages/InnermapCaseStudy';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/work/embr" element={<EmbrCaseStudy data-id="element-7" />} data-id="element-6" />
          <Route path="/work/ginkgo" element={<GinkgoCaseStudy data-id="element-9" />} data-id="element-8" />
          <Route path="/work/innermap" element={<InnermapCaseStudy data-id="element-11" />} data-id="element-10" />
        </Routes>
      </div>
    </Router>;
}